import React, { useState, useEffect, useCallback, useRef } from 'react';
import { apiFetch } from '../lib/api';
import { Icons } from '../components/icons';
import { actionLabel, formatAuditSummary, formatRelativeTime } from '../lib/auditLabels';

export function PlatformNotificationBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const ref = useRef(null);

  const fetchItems = useCallback(() => {
    apiFetch('/api/v1/platform/audit-logs?page=1&page_size=6').then(d => {
      if (d.code !== 0) return;
      const list = d.data?.items || [];
      setItems(list);
      const seen = localStorage.getItem('admin_audit_seen_at') || '';
      const unseen = list.filter(it => !seen || new Date(it.created_at) > new Date(seen)).length;
      setUnreadCount(unseen);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    fetchItems();
    const iv = setInterval(fetchItems, 60000);
    return () => clearInterval(iv);
  }, [fetchItems]);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const openDropdown = () => {
    setOpen(v => !v);
    if (!open) {
      localStorage.setItem('admin_audit_seen_at', new Date().toISOString());
      setUnreadCount(0);
    }
  };

  return (
    <div className="notif-bell" ref={ref} style={{position:'relative'}}>
      <div onClick={openDropdown} title="平台动态"><Icons.Bell w="18" h="18"/></div>
      {unreadCount > 0 && <span className="notif-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>}
      {open && <div className="notif-dropdown">
        <div className="notif-dropdown-header">
          <span>平台动态</span>
          <span style={{fontSize:11,fontWeight:400,color:'var(--brand-text-muted)'}}>
            {unreadCount > 0 ? `${unreadCount} 条新` : '最近'}
          </span>
        </div>
        <div className="notif-dropdown-body">
          {items.length === 0
            ? <div className="notif-empty">暂无动态</div>
            : items.map(it => (
              <div
                key={it.id}
                className="notif-dropdown-item"
                onClick={() => { setOpen(false); window.dispatchEvent(new CustomEvent('nav',{detail:'audit'})); }}
                title={[actionLabel(it.action), formatAuditSummary(it), new Date(it.created_at).toLocaleString('zh-CN')].filter(Boolean).join('\n')}
              >
                <div className="notif-item-dot"/>
                <div className="notif-item-content">
                  <div className="notif-item-row">
                    <div className="notif-item-title">{actionLabel(it.action)}</div>
                    <div className="notif-item-time">{formatRelativeTime(it.created_at)}</div>
                  </div>
                  <div className="notif-item-msg">{formatAuditSummary(it, { compact: true })}</div>
                </div>
              </div>
            ))}
        </div>
        <div className="notif-dropdown-footer">
          <a href="#" onClick={e => { e.preventDefault(); setOpen(false); window.dispatchEvent(new CustomEvent('nav',{detail:'audit'})); }}>查看全部审计</a>
        </div>
      </div>}
    </div>
  );
}
